/**
 * Prévia de e-mail — o HTML de verdade, num iframe sem scripts.
 *
 * Serve à listagem (miniatura), ao editor (aba Visual) e ao inspetor da régua
 * (prévia da ação). `comExemplos` troca as variáveis pelos valores do catálogo
 * — é o "alguns replaces" que deixa o operador ver o e-mail como a escola vai
 * ver, sem mandar nada.
 */

import { aplicarVariaveis, valoresExemplo } from '@egba-do/shared'
import { useMemo } from 'react'

export function MiniEmail({
  html,
  comExemplos = true,
  altura = 220,
  interativa = false,
}: {
  html: string
  comExemplos?: boolean
  altura?: number | string
  interativa?: boolean
}) {
  const doc = useMemo(() => {
    const corpo = comExemplos ? aplicarVariaveis(html, valoresExemplo()) : html
    // Sem <base>: o template não deve depender de recurso relativo nenhum.
    return corpo
  }, [html, comExemplos])

  return (
    <iframe
      title="Prévia do e-mail"
      srcDoc={doc}
      sandbox=""
      tabIndex={-1}
      loading="lazy"
      className={`w-full rounded-lg border border-[color:var(--color-borda)] bg-white ${
        interativa ? '' : 'pointer-events-none'
      }`}
      style={{ height: altura }}
    />
  )
}
